import React, { useCallback, useMemo, useState } from 'react';
import { observer } from 'mobx-react';
import cm from 'classnames';
import { Icon } from 'ksnm-common-ui/lib/Icon';

import { menuFullWidthByCss } from '@common/DesignLayout/DesignMenu/constantts';
import { designMenuStore } from '@stores/designMenuStore';

import { DesignSubMenuItem } from './DesignSubMenuItem';

import styles from './DesignSubMenu.module.scss';

function DesignSubMenuComponent({ menuWidth }: { menuWidth: number }): JSX.Element {
  const { menuData, rmMenuData } = designMenuStore;
  const [open, setOpen] = useState<string | number | undefined>(undefined);

  const routes = useMemo(() => {
    if (menuData.length) return menuData[0].routes?.filter((f) => !f.hidden) ?? [];
    return [];
  }, [menuData]);

  const onCloseMenu = useCallback(() => {
    rmMenuData(true);
  }, [rmMenuData]);

  return (
    <div className={cm(styles.subMenu, { [styles.full]: menuWidth === menuFullWidthByCss })}>
      <div className={styles.subMenuTitle}>Информационная система &quot;Расчетный модуль&quot;</div>
      <div className={styles.subMenuWrapper}>
        {routes?.map((route, idx) => (
          <div key={idx}>
            {route?.withTopDivider && <div className={styles.divider} />}
            <DesignSubMenuItem
              setOpen={setOpen}
              open={open}
              item={route}
              key={`${route.title ?? ''} ${route.path ?? ''}`}
            />
          </div>
        ))}
      </div>
      <button className={styles.backButton} type="button" tabIndex={-1} onClick={onCloseMenu}>
        <Icon name="arrowToLeft" noFill />
      </button>
    </div>
  );
}

export const DesignSubMenu = observer(DesignSubMenuComponent);
